var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViews = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 9,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.93 4.03C13.79 1.43 11 0 8 0S2.2 1.43.07 4.03c-.1.13-.1.3 0 .43 2.14 2.57 4.93 4 7.93 4s5.8-1.43 7.93-4.03c.1-.1.1-.3 0-.4M8 7.43a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.6 4.23a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0"
})));
export default SvgViews;